module.exports = __webpack_public_path__ + "static/media/attempted.fd832f3a.svg";